import 'bootstrap';
import '../css/style.scss';
import { App } from './App.js';

function isLowPerformanceDevice() {
    // 1. Проверяем оперативную память (работает в Chromium-браузерах)
    // Если памяти 4 ГБ или меньше — устройство считается слабым
    if (navigator.deviceMemory && navigator.deviceMemory <= 4) {
        return true;
    }

    // 2. Проверяем количество ядер процессора
    // Если ядер 4 или меньше — это бюджетный процессор
    if (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) {
        return true;
    }

    // 3. Проверяем качество сети (Network Information API)
    if (navigator.connection) {
        const connection = navigator.connection;
        // Если тип сети 2g/3g или включен режим сохранения трафика
        if (connection.saveData || ['slow-2g', '2g', '3g'].includes(connection.effectiveType)) {
            return true;
        }
    }

    return false;
}

if (isLowPerformanceDevice()) {
    console.log("Включаем облегченную версию сайта");
    document.documentElement.classList.add('low-perf');
    // Здесь можно отключить тяжелые скрипты
}

// показать 1 главу вместо полного текста
const urlParams = new URLSearchParams(window.location.search);
if (!urlParams.has('range')) {
    urlParams.set('range', '1-35');
    const newUrl = window.location.pathname + '?' + urlParams.toString();
    // 5. Явно обновляем URL в адресной строке без перезагрузки страницы
    window.history.replaceState({ path: newUrl }, '', newUrl);
}

document.addEventListener('DOMContentLoaded', () => {
    const app = new App();
    app.init();
});